import React, {useState, useEffect} from 'react';
import { List, Checkbox, Button } from 'antd-mobile';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import Layouts from '../../components/layouts/Layouts';
import { create } from '../../services/live';
import {edit as editUser} from '../../services/user';
import { createLiveForMatch, cancelLive } from '../../actions/matchDataActions';
import { me, extract } from '../../helpers';
import BecomingLiveScorerConfirmationModal from '../../components/modals/BecomingLiveScorerConfirmationModal';
import './ProfileSettingsForm.css';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import Toolbar from '../../components/headers/home/Toolbar';
import ServerErrorModal from '../../components/modals/error/ServerErrorModal';
import axios from 'axios';
import { API_HOST } from '../../config.env';

const ProfileSettingsForm = props => {
    const [ formValid, setFormValid ] = useState(false);
    const [ nickname, setNickname ] = useState(me().nickname);
    const [legalCondition] = useState(true);
    const [show, setShow] = useState(false);
    const [error, setError] = useState(null);
    const [live, setLive] = useState([]);
    const access = props.connexionReducer;
    const [isOnSubmit, setIsOnSubmit] = useState(false);

    useEffect(() => {
        setFormValid(nickname !== null && nickname !== '' && legalCondition)
    }, [nickname, legalCondition]);

    return(
        <Layouts modifier='ls_page_action_form' toolbar={() => <Toolbar title='devenir live scorer' back='/matches' />} >
            <div className='ls_profile_settings'>
                <List renderHeader={() => <Title text='Tu souhaites signer ton live comme' /> }>
                    {
                        nicknames().map((n,k) => (
                            <List.Item key={k} onClick={() => setNickname(n)} multipleLine>
                                <Checkbox
                                    defaultChecked={n === nickname}
                                    checked={n === nickname}
                                    onChange={() => setNickname(n)}
                                ><span style={{marginLeft: '10px'}} className='common'>{n}</span></Checkbox>
                            </List.Item>
                        ))
                    }
                </List>
                <div style={{position: props.position || 'absolute',top: 'auto', bottom: '0', margin: '20px', width: '88%'}}>
                    <Button
                        loading={isOnSubmit}
                        style={{textTransform: 'uppercase', backgroundColor: '#004586', color: '#fff', fontFamily: 'fff-equipe', borderRadius: '50px', fontSize: '16px'}} 
                        disabled={!formValid} 
                        onClick={() => handleValidForm(formValid, nickname ,access, props,l => {setShow(!show); setLive(l)}, (reject) => setError(reject), setIsOnSubmit)}
                    >
                        valider
                    </Button>
                </div>
                <BecomingLiveScorerConfirmationModal 
                    show={show}
                    cancel={() => {
                        const id = extract(live['@id'], '/', 3);
                        axios.delete(`${API_HOST}/api/lives/${id}`,{headers: {
                            Accept: 'application/ld+json',
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${access}`
                        }}).then(() => {
                            const {maNo} = props.match.params;
                            props.cancelLive(id, maNo);
                            props.history.push('/matches');
                            setShow(false)
                        })
                    }}
                    done={()=> {
                        props.history.push('/matches');
                        setShow(false)
                    }} />
                <ServerErrorModal error={error} />
            </div>
        </Layouts>
    )
}

const nicknames = () => [`${me().firstname} ${me().lastname}`,`${me().firstname}.${me().lastname.charAt(0).toUpperCase()}`,`LiveScorer${me().id}`];

const Title = props => <div className='common' style={{fontWeight: '700'}}>{props.text}</div>

const handleValidForm = (formValid, nickname, access, props, callback, reject, setIsOnSubmit) => {
    if(formValid) {
        setIsOnSubmit(true);
        const {maNo} = props.match.params;
        const userData = { nickname }
        editUser(userData, access).then(r => {
            if(r.status === 200) {
                sessionStorage.setItem('me', JSON.stringify( _.assign(_.pick(r.data, ['email', 'ssoId', 'firstname', 'lastname', 'nickname']), {id: me().id}) ));
            }
        })
        if(maNo){
            const qs = queryString.parse(props.history.location.search);
            create(maNo, qs.homeTeam, qs.awayTeam, qs.matchDate, access)
                .then(response => {
                    if(response.status === 201) {
                        window.postMessage(JSON.stringify({
                            action: 'trackEventWithCollection',
                            parameters: {
                                label: 'declared_live_scorer',
                                collection: {match_name: `${props.homeTeam} x ${props.awayTeam}`}
                            }
                        }), '*');
                        props.createLiveForMatch(response.data, maNo);
                        callback(response.data);
                    }
                })
                .catch(error => {
                    const {data} = error.response;
                    reject({code: error.response.status, data});
                })
                .finally(() => setIsOnSubmit(false))
        }
        else{
            setIsOnSubmit(false);
            redirect(props.history);
        }   
    }
}

const redirect = history => history.goBack();

const mapStateToProps = ({connexionReducer}) => ({connexionReducer});

const mapDispatchToProps = dispatch => bindActionCreators({createLiveForMatch, cancelLive}, dispatch);

ProfileSettingsForm.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    createLiveForMatch: PropTypes.func.isRequired
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(ProfileSettingsForm));